/* @ngInject */
export default function routes($routeProvider) {
    $routeProvider
        .when('/', {
            redirectTo: '/login',
        })
        .when('/login', {
            template: '<sb-login></sb-login>',
            public: true,
        })
        .when('/home', {
            template: '<sb-home></sb-home>',
        })
        .when('/transports', {
            template: '<sb-transports></sb-transports>',
        })
        .when('/detail/:id', {
            template: '<sb-detail></sb-detail>',
        })
        .when('/report/carts', {
            template: '<sb-carts-report></sb-carts-report>',
        })
        .otherwise({
            redirectTo: '/',
        });
}



// WEBPACK FOOTER //
// ./src/app/config/routes.js